// third-party
import { FormattedMessage } from "react-intl";

// assets
import {
  IconBrandFacebook,
  IconDashboard,
  IconDeviceAnalytics,
  IconList,
  IconPackage,
  IconQuestionMark,
  IconShoppingCart,
  IconSubscript,
  IconUserStar,
} from "@tabler/icons-react";

// constant
const icons = {
  IconDashboard,
  IconDeviceAnalytics,
  IconSubscript,
  IconShoppingCart,
  IconBrandFacebook,
  IconPackage,
  IconUserStar,
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = (photograph) => ({
  id: "dashboard",
  title: <FormattedMessage id="menu.dashboard" />,
  type: "group",
  children: [
    {
      id: "default",
      title: <FormattedMessage id="menu.dashboard" />,
      type: "item",
      url: "/dashboard",
      regexUrl: /\/dashboard/,
      icon: icons.IconDashboard,
      breadcrumbs: false,
    },
    {
      id: "albums",
      title: (
        <>
          <FormattedMessage id="menu.albums" />
        </>
      ),
      type: "item",
      url: "/dashboard/albums",
      regexUrl: /\/dashboard\/albums/,
      chip: {
        color: "secondary",
        variant: "outlined",
        size: "small",
        label: photograph ? photograph.photograph_albums_count : "",
      },
      icon: icons.IconDeviceAnalytics,
      breadcrumbs: true,
    },
    {
      id: "packages",
      title: <FormattedMessage id="menu.packages" />,
      type: "item",
      url: "/dashboard/packages",
      regexUrl: /\/dashboard\/packages/,
      icon: icons.IconPackage,
      breadcrumbs: true,
    },
    {
      id: "divider1",
      type: "divider",
      breadcrumbs: false,
    },
    {
      id: "orders",
      title: <FormattedMessage id="menu.orders" />,
      type: "collapse",
      icon: icons.IconShoppingCart,
      breadcrumbs: true,
      children: [
        {
          id: "orders-dashboard",
          title: <FormattedMessage id="menu.orders-dashboard" />,
          type: "item",
          url: "/dashboard/orders",
          regexUrl: /\/dashboard\/orders/,
          icon: IconDashboard,
          breadcrumbs: true,
        },
        {
          id: "orders-list",
          title: <FormattedMessage id="menu.orders-list" />,
          type: "item",
          url: "/dashboard/orders/list",
          regexUrl: /\/dashboard\/orders\/list/,
          icon: IconList,
          breadcrumbs: true,
        },
      ],
    },
    {
      id: "public-profile",
      title: <FormattedMessage id="menu.public-profile" />,
      type: "item",
      url: "/dashboard/public-profile",
      regexUrl: /\/dashboard\/public-profile/,
      icon: icons.IconBrandFacebook,
      breadcrumbs: true,
    },
    {
      id: "divider2",
      type: "divider",
      breadcrumbs: false,
    },
    {
      id: "subscription",
      title: <FormattedMessage id="menu.subscription" />,
      type: "item",
      url: "/dashboard/subscription",
      regexUrl: /\/dashboard\/subscription/,
      icon: icons.IconSubscript,
      breadcrumbs: true,
    },
    {
      id: "faq",
      title: <FormattedMessage id="menu.faq" />,
      type: "item",
      url: "https://documentation.eventpxl.com",
      icon: IconQuestionMark,
    },
  ],
});

export default dashboard;
